import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { isEmptyValue, sortByProperty, sortByPropertyLowerCase } from '@/utils/utils';
import SubjectList from '@/components/subject-list/subject-list';
import DropdownCheck from '@/components/dropdown-check/dropdown-check';
import { copy } from '@/utils/cohort';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { sessionService } from '@/providers/services/auth/session';
import { watch } from 'vue';
import { SUPER_ADMIN_TENANT } from '@/utils/constants';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';


@Component({
    name: 'subjects-facets',
    components: {
        'material-icons': GoogleMaterialIcon,
        'mc-icons': MCIcon,
        'dropdown-check': DropdownCheck,
        'subject-list': SubjectList,
    },
})

export default class SubjectsFacets extends Vue {

    // -----------------------------------------------------------------
    // Properties
    @Prop()
    public classification: any = [];  // for classifiction array
    public subjectClassificationsList: any = {};  // for subject classfiction array
    public isDisplayList: boolean = false;  // for to show list in UI after getting all data from API
    public subjectClassificationFramework: any = {};  // framework list in each classifiction for dropdown
    public selectedFramework: any = {};   // for selecting item by name in drop down
    public selectedDefaultCheckbox: any = {};  // for selecting default in each dropdown
    public selectedItemArray: any = [];
    public isLoading: boolean = false;
    public allSettingKeys: any = [];
    public tenantSettingList: any = [];
    public ignoreForSelection: any = ['STARI Boost', 'STARI Fluency',
        'TOEFL',
        'SEL-CASEL',
        'Life Right Here and Everywhere',
        'Sylvan Ace It C and D',
        'Sylvan Ace It E',
        'Sylvan Ace It F',
        'SA-Math',
        'TZ-Math',
        'Sylvan Ace It G',
        'Sylvan Ace It H',
        'Database Management Systems',
        'Vision Technician',
        'POSH (NLC)',
        'POSH',
        'Communication',
        'Techniques',
        'Problem Solving',
        'Railway Recruitment Board Coaching',
        'Transformer Manufacturing',
        'Forklift Operator',
        'Ugam 101',
        'PD Onboarding',
        'BD Onboarding',
        'Soft Skills 1',
        'Leadership',
        'Pre-RTH',
        'Trainer Performance Assessment',
        'Forklift Safety Training',
        'PSB Onboarding',
        'SAP Mentor Framework',
        'SAP Machine Learning',
        'Microservice Development on SAP Cloud Platform',
        'SAP Product Standards and Support Processes',
        'SAP Performance and Scalability',
        'Introduction to ABAP and RAP',
        'SAP User Experience',
        'SAP HANA',
        'User Interface',
        'Data Intelligence',
        'Electrical Systems and Maintenance Level 5',
        'Certificate Programme in Computer Accounting',
        'Automotive Manufacturing Technician',
        'Electrical Systems and Maintenance Level 3',
        'Electrical Systems and Maintenance Level 4',
        'BVoc (Business Administration)',
        'Bindaas Bol',
        'Employability Skills',
        'Electrician',
        'Fitter',
        'Garment Construction Techniques',
        'Data Entry Operator',
        'Soft skills',
        'Industrial Electrician',
        'Industrial Fitter',
        'LU-Digital Literacy',
        'Mechanic Motor Vehicle',
        'Manufacturing Technology Level 3',
        'Manufacturing Technology Level 4',
        'Manufacturing Technology Level 5',
        'Reading',
        'Spoken English and Career Awareness',
        'Social and Emotional Learning',
        'Skills For Success',
        'Employability Skills- Common Course',
        'Sewing Machine Operator',
        'Soft Skills (Learnet)',
        'Welding',
        'B.Voc Manufacturing Technology Level 5',
        'Employability Skills - India',
        'Soft skills for Employability',
        'Certificate Programme in Computer Basics',
        'Applied Deep Learning',
        'College Skills',
        'English',
        'xAPI program',
        'Sexual Literacy for Children',
        'NCERT - Science',
        'Maths',
        'Marathi',
        'Life Skills',
        'Hindi',
        'Marathi',
        'Math LU Pilot',
        'English',
        'Local Governance- Panchayati raj',
        'Indigu Führungskräfteentwicklung',
        'Learning Navigator',
        '100% community',
        'Montessori',
        'Parents as Early Teachers',
    ];

    public ignoreForClassifierSelection: any = ['TLA', 'HOS', 'NL', 'CD'];

    public selectedCategory: any = {};

    public selectedSubAndFw: any = [];

    public get loggedTenantId() {
        return this.$access.getTenantId();
    }

    public get filteredTenantList() {
        return this.tenantList.filter((item: any) => {
            return item.name.toLowerCase().indexOf(this.tenantSearchText.toLowerCase()) > -1;
        });
    }

    public tenantList: any = [];

    public selectedTenant: any = [];

    public tenantSearchText: string = '';

    public adminTenant: string = SUPER_ADMIN_TENANT;

    // @Watch('selectedTenant')
    // public async onChangeTenant(value: any) {
    //     this.selectedTenant = value;
    //     await this.fetchTenantSettingsById(value.id);
    //     await this.categoryLists();

    // }

    // ------------------------------------------------------------------
    // Actions

    public async created() {
        const tenantId: string = this.selectedTenant && this.selectedTenant.id
            ? this.selectedTenant.id : this.loggedTenantId;
        await this.fetchTenantList();
        await this.fetchTenantSettingsById(tenantId);
        await this.categoryLists();

    }

    public async fetchTenantSettingsById(tenantId: string) {
        this.tenantSettingList = [];
        const data = await tenantSettingsAPI.fetchTenantSettingById(tenantId);
        this.tenantSettingList = data;
    }

    public fetchTenantList() {
        const params = {
            offset: 0,
            limit: 500,
        };

        adminUtilsAPI.fetchTenantList(params).then((data: any) => {
            sortByPropertyLowerCase(data.list, 'name', 'ASC');
            this.tenantList = data.list;
            const tenantId = this.loggedTenantId;
            const activeTenant = this.tenantList.filter((item: any) => item.id === tenantId);
            this.selectedTenant = activeTenant[0];

        });
    }

    public async onSelectTenant(tenant: any) {
        const tenantDd = (this.$refs as any).tenantDd;
        if (tenantDd) {
            tenantDd.hide(true);
        }
        this.selectedTenant = tenant;
        await this.fetchTenantSettingsById(tenant.id);
        await this.categoryLists();
    }

    public onSelectFramework(item: any, category: any, subjectObject: any) {
        const objectIndex = this.classification.findIndex((classItem: any) => classItem.id === category);
        const subjectObjectIndex = this.classification[objectIndex].subjectList
            .findIndex((subItem: any) => subItem.id === subjectObject.id);
        this.$set(this.classification[objectIndex].subjectList, subjectObjectIndex, subjectObject);
        this.$set(this.classification[objectIndex], 'subjectList', this.classification[objectIndex].subjectList);
        this.$set(this.classification, objectIndex, this.classification[objectIndex]);
    }

    public onSelectDefaultCheckbox(item: any, category: any, subjectObject: any) {
        const objectIndex = this.classification.findIndex((classItem: any) => classItem.id === category);
        const subjectObjectIndex = this.classification[objectIndex].subjectList
            .findIndex((subItem: any) => subItem.id === subjectObject.id);
        this.$set(this.classification[objectIndex].subjectList, subjectObjectIndex, subjectObject);
        this.$set(this.classification[objectIndex], 'subjectList', this.classification[objectIndex].subjectList);
        this.$set(this.classification, objectIndex, this.classification[objectIndex]);
    }

    public onSelectSubjectFacets(sub: any, category: any) {
        const objectIndex = this.classification.findIndex((classItem: any) => classItem.id === category);
        this.$set(this.classification, objectIndex, this.classification[objectIndex]);
    }


    public onSaveSettings(group: any = null) {
        this.$bvModal.show('tenant-confirmation');
    }

    public hideModal() {
        this.$bvModal.hide('tenant-confirmation');
    }

    public async updateSettings() {
        const that = this;
        const sumbitKeys = ['tx_sub_prefs', 'tx_fw_prefs'];
        const settingsConfig: any = {
            tx_sub_prefs: {},
            tx_fw_prefs: {},
        };
        const classification = copy(that.classification);
        for (const classify of classification) {
            settingsConfig.tx_sub_prefs[classify.id] = {};
            const subjectList = classify.subjects;
            for (const subject of subjectList) {
                settingsConfig.tx_fw_prefs[subject.id] = {};
                if (subject.isChecked) {
                    settingsConfig.tx_sub_prefs[classify.id].gut_subject_codes =
                        settingsConfig.tx_sub_prefs[classify.id].gut_subject_codes || [];
                    settingsConfig.tx_sub_prefs[classify.id].is_global_visible = false;
                    if (!settingsConfig.tx_sub_prefs[classify.id].gut_subject_codes.includes(subject.id)) {
                        settingsConfig.tx_sub_prefs[classify.id].gut_subject_codes.push(subject.id);
                    }
                }
                if (subject.isDefault) {
                    settingsConfig.tx_sub_prefs[classify.id].default_gut_subject_code = subject.id;
                }

                if (subject.frameworks && subject.frameworks.length > 0) {
                    settingsConfig.tx_fw_prefs[subject.id].fw_ids =
                        settingsConfig.tx_fw_prefs[subject.id].fw_ids || [];
                    settingsConfig.tx_fw_prefs[subject.id].is_global_visible = false;
                    for (const selectedFw of subject.frameworks) {
                        if (selectedFw.isChecked) {
                            settingsConfig.tx_fw_prefs[subject.id].fw_ids.push(selectedFw.standard_framework_id);
                        }
                        if (selectedFw.isDefault) {
                            settingsConfig.tx_fw_prefs[subject.id].default_fw_id = selectedFw.standard_framework_id;
                        }
                    }
                }
            }
        }
        Object.keys(settingsConfig.tx_sub_prefs).forEach((sub: any) => {
            if (isEmptyValue(settingsConfig.tx_sub_prefs[sub].gut_subject_codes)) {
                delete settingsConfig.tx_sub_prefs[sub];
            }
        });
        Object.keys(settingsConfig.tx_fw_prefs).forEach((sub: any) => {
            if (settingsConfig.tx_fw_prefs[sub].fw_ids.length === 0) {
                delete settingsConfig.tx_fw_prefs[sub];
            }
        });
        this.isLoading = true;
        const tenantId = this.selectedTenant ? this.selectedTenant.id : this.loggedTenantId;
        for await (const [index, key] of sumbitKeys.entries()) {
            this.isLoading = true;
            const config: any = {};
            config.tenant_key = key;
            config.value = JSON.stringify(settingsConfig[key]);
            config.setting_visibility = that.getVisiblitySetting(key);
            config.tenant_id = tenantId;
            await tenantSettingsAPI.updateTenantSettings(config);
            if (index === sumbitKeys.length - 1) {
                const data = await tenantSettingsAPI.fetchTenantSettingById(tenantId);
                this.tenantSettingList = data;
                this.categoryLists();
                this.isLoading = false;
                this.hideModal();
            }
        }
    }

    public getVisiblitySetting(settingsKey: any) {
        const itemIndex: any = this.allSettingKeys.findIndex((item: any) => {
            return item.settingKey === settingsKey;
        });
        if (itemIndex !== -1) {
            return this.allSettingKeys[itemIndex].settingVisibility;
        }
    }

    public async categoryLists() {
        this.isLoading = true;
        this.isDisplayList = false;
        this.selectedSubAndFw = [];
        this.selectedCategory = [];
        this.classification = await (this.selectedTenant && this.selectedTenant.id ?
            taxonomyAPI.fetchTaxonomyClassificationsList() : taxonomyAPI.fetchTaxonomyClassifications());
        const {
            tx_sub_classifier_prefs = { ids: [] },
            tx_sub_prefs = {},
            tx_fw_prefs = {},
        } = this.tenantSettingList || {};
        for await (const category of this.classification) {
            const isClassifierSelected = tx_sub_classifier_prefs.ids.includes(category.id);
            category.isChecked = isClassifierSelected;
            const subjectData = await (this.selectedTenant && this.selectedTenant.id ?
                taxonomyAPI.fetchSubjectsList(category.id) : taxonomyAPI.fetchSubjects(category.id));
            const txSubPrefs = tx_sub_prefs[category.id] || null;

            for await (const item of subjectData) {
                const txFwPrefs = tx_fw_prefs[item.id] || null;
                const isSubjectSelected = txSubPrefs && txSubPrefs.gut_subject_codes
                    ? txSubPrefs.gut_subject_codes.includes(item.id)
                    : false;

                item.isDefault = txSubPrefs && txSubPrefs.default_gut_subject_code === item.id;
                item.isChecked = isClassifierSelected
                    ? txSubPrefs ? isSubjectSelected : true
                    : isSubjectSelected;
                for await (const fw of item.frameworks) {
                    const isFwSelected = txFwPrefs && txFwPrefs.fw_ids
                        ? txFwPrefs.fw_ids.includes(fw.standard_framework_id)
                        : false;
                    const isSubjectValid = isClassifierSelected
                        ? txSubPrefs ? isSubjectSelected : true
                        : isSubjectSelected;

                    fw.isDefault = txFwPrefs && txFwPrefs.default_fw_id === fw.standard_framework_id;
                    fw.isChecked = isSubjectValid
                        ? txFwPrefs ? txFwPrefs.fw_ids.includes(fw.standard_framework_id) : true
                        : txFwPrefs ? txFwPrefs.fw_ids.includes(fw.standard_framework_id) : false;


                }
            }
            subjectData.sort((a: any, b: any) => Number(b.isChecked) - Number(a.isChecked));
            category.subjects = subjectData;
        }
        this.selectedCategory = this.classification[0];
        this.selectedSubAndFw = this.selectedCategory && this.selectedCategory.subjects || [];
        this.isDisplayList = true;
        this.allSettingKeys = await tenantSettingsAPI.fetcTenantConfigKeysRawList();
        this.isLoading = false;
    }

    public onSelectCategory(category: any, index: number) {
        this.selectedCategory = category;
        this.selectedSubAndFw = category.subjects;
    }

    public async onUpdateFw(category: any, subject: any, itemFw: any) {
        const selectedFw = itemFw;
        const objectIndex = this.classification.findIndex((classItem: any) => classItem.id === category.id);
        const subjectObjectIndex = this.classification[objectIndex].subjects
            .findIndex((subItem: any) => subItem.id === subject.id);
        this.$set(this.classification[objectIndex].subjects[subjectObjectIndex], 'isChecked', true);
    }
}
